import { useTranslate } from '@va/localization';
import { SectionHeader } from '@va/ui/components/white-label-customisation';
import { TabbedButton } from '@va/ui/design-system';
import { useEffect, useMemo, useRef, useState } from 'react';
import CustomDomain from './CustomDomain';
import CustomSubdomainContainer from './CustomSubdomainContainer';
import { useGetLiveAgencyDomain } from './useGetLiveAgencyDomain';

const CustomDomainsSection = () => {
  const translate = useTranslate();

  const { domainType } = useGetLiveAgencyDomain();

  const initialChange = useRef<boolean>(true);

  const getInitialSelectedTab = function (): number {
    if (!domainType) return 0;
    if (domainType === 'custom-subdomain') return 0;
    initialChange.current = false;
    return 1;
  };

  const [selectedTabIndex, setSelectedTabIndex] = useState(getInitialSelectedTab());

  useEffect(() => {
    if (!domainType) return;
    if (domainType === 'custom-subdomain') {
      setSelectedTabIndex(0);
    }
    if (domainType === 'custom-domain') {
      initialChange.current = false;
      setSelectedTabIndex(1);
    }
  }, [domainType]);

  const domainTabs = useMemo(
    () => [
      {
        label: translate('customDomains.tabs.subdomain.title'),
        tooltip: translate('customDomains.tabs.subdomain.tooltip'),
        value: 0,
        className: '!w-full !h-54 sm-initial:flex-1',
      },
      {
        label: translate('customDomains.tabs.customDomain.title'),
        tooltip: translate('customDomains.tabs.customDomain.tooltip'),
        value: 1,
        className: '!w-full !h-54 sm-initial:flex-1',
      },
    ],
    [translate],
  );

  return (
    <div className='flex flex-col gap-5'>
      <SectionHeader
        title={translate('whiteLabel.customization.customDomain.title')}
        description={translate('whiteLabel.customization.customDomain.description')}
      />

      <TabbedButton
        className='!h-auto flex-col sm-initial:flex-row'
        buttonOptions={domainTabs}
        selectedValue={selectedTabIndex}
        onChange={setSelectedTabIndex}
      />
      {selectedTabIndex === 0 && <CustomSubdomainContainer />}
      {selectedTabIndex === 1 && <CustomDomain />}
    </div>
  );
};

export default CustomDomainsSection;
